import * as React from "react";
import ScrollyContainer from "src/containers/ScrollyContainer";
import "./App.scss";

class App extends React.Component {
  private data = require("./data.json");

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div className="App">
        <ScrollyContainer data={this.data} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx